import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../supabase';
import { useSiteLang as useLang } from '../siteLang';
import Footer from '../components/Footer';
import smiley from '../winston-smiley-white.svg';

// Même refonte que Login.jsx / Signup.js.

const t = {
    fr: {
        windowTitle: 'winston.ie — Mot de passe oublié',
        subtitle: 'Entre ton nom d\'utilisateur, on t\'envoie un lien.',
        username: 'Nom d\'utilisateur',
        submit: 'Envoyer le lien',
        sentTitle: 'Vérifie ta boîte mail',
        sentBody: 'Un lien de réinitialisation a été envoyé.',
        backToLogin: 'Retour à la connexion',
        back: '← Retour à la connexion',
        errNotFound: 'Nom d\'utilisateur introuvable.',
        backHome: '← winston.ie',
    },
    en: {
        windowTitle: 'winston.ie — Forgot password',
        subtitle: 'Enter your username, we\'ll send you a reset link.',
        username: 'Username',
        submit: 'Send reset link',
        sentTitle: 'Check your email',
        sentBody: 'A reset link has been sent to your email.',
        backToLogin: 'Back to login',
        back: '← Back to login',
        errNotFound: 'Username not found.',
        backHome: '← winston.ie',
    },
    vi: {
        windowTitle: 'winston.ie — Quên mật khẩu',
        subtitle: 'Nhập tên người dùng, chúng tôi sẽ gửi liên kết đặt lại.',
        username: 'Tên người dùng',
        submit: 'Gửi liên kết',
        sentTitle: 'Kiểm tra email của bạn',
        sentBody: 'Liên kết đặt lại mật khẩu đã được gửi.',
        backToLogin: 'Quay lại đăng nhập',
        back: '← Quay lại đăng nhập',
        errNotFound: 'Không tìm thấy tên người dùng.',
        backHome: '← winston.ie',
    },
};

const UI_FONT = "'Helvetica Neue', Arial, sans-serif";
const INK = '#0e1013';
const BG = '#faf9f6';
const BORDER = '#e5e5e0';
const MUTED = '#8a8a86';
const ERR_BG = '#fdf2f1';
const ERR_BORDER = '#e0a89f';
const ERR_TEXT = '#a3382f';

const fieldStyle = {
    width: '100%',
    border: `1px solid ${BORDER}`,
    padding: '11px 12px',
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: UI_FONT,
    color: INK,
    outline: 'none',
    boxSizing: 'border-box',
    background: '#fff',
};

function ForgotPassword() {
    const navigate = useNavigate();
    const { lang, cycleLang } = useLang();
    const c = t[lang] || t.fr;
    const title = c.windowTitle.replace('winston.ie — ', '');

    const [username, setUsername] = useState('');
    const [sent, setSent] = useState(false);
    const [error, setError] = useState('');

    const handleReset = async () => {
        setError('');
        const { data, error: fetchError } = await supabase
            .from('users')
            .select('email')
            .eq('username', username)
            .single();

        if (fetchError || !data) {
            setError(c.errNotFound);
            return;
        }

        const { error: resetError } = await supabase.auth.resetPasswordForEmail(data.email, {
            redirectTo: `${window.location.origin}/reset-password`,
        });

        if (resetError) {
            setError(resetError.message);
            return;
        }

        setSent(true);
    };

    useEffect(() => { document.title = 'Forgot Password | winston.ie'; }, []);

    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: BG, fontFamily: UI_FONT }}>
            <style>{`
                .wlink { position: relative; display: inline-block; cursor: pointer; opacity: 0.88; transition: opacity .25s ease; }
                .wlink:hover { opacity: 1; }
                .wlink::after { content: ''; position: absolute; left: 0; right: 0; bottom: -3px; height: 1px; background: currentColor; transform: scaleX(0); transform-origin: left; transition: transform .35s cubic-bezier(.4,0,.2,1); }
                .wlink:hover::after { transform: scaleX(1); }
            `}</style>

            <div style={{ padding: '24px 28px' }}>
                <p onClick={() => navigate('/')} className="wlink" style={{ fontSize: '13px', fontWeight: 500, color: INK, margin: 0 }}>{c.backHome}</p>
            </div>

            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
                <div style={{ width: '100%', maxWidth: '380px', background: '#fff', border: `1px solid ${BORDER}`, padding: '40px 32px' }}>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '28px' }}>
                        <img src={smiley} alt="winston.ie" style={{ height: '32px', width: 'auto', filter: 'invert(1)' }} />
                        <button onClick={cycleLang} className="wlink" style={{ background: 'none', border: 'none', padding: 0, fontFamily: UI_FONT, fontWeight: 500, fontSize: '12px', color: MUTED, cursor: 'pointer' }}>
                            {lang.toUpperCase()}
                        </button>
                    </div>

                    {sent ? (
                        <>
                            <h1 style={{ fontFamily: UI_FONT, fontWeight: 700, fontSize: '21px', color: INK, margin: '0 0 8px', letterSpacing: '-0.01em' }}>{c.sentTitle}</h1>
                            <p style={{ fontFamily: UI_FONT, fontWeight: 500, fontSize: '13px', color: MUTED, margin: '0 0 24px' }}>{c.sentBody}</p>
                            <button onClick={() => navigate('/login')} className="wlink" style={{ display: 'block', width: '100%', textAlign: 'center', background: 'none', border: 'none', padding: '4px 0', fontFamily: UI_FONT, fontWeight: 700, fontSize: '14px', color: INK, cursor: 'pointer' }}>{c.backToLogin}</button>
                        </>
                    ) : (
                        <>
                            <h1 style={{ fontFamily: UI_FONT, fontWeight: 700, fontSize: '21px', color: INK, margin: '0 0 6px', letterSpacing: '-0.01em' }}>{title}</h1>
                            <p style={{ fontFamily: UI_FONT, fontWeight: 500, fontSize: '13px', color: MUTED, margin: '0 0 24px' }}>{c.subtitle}</p>

                            <div style={{ marginBottom: '18px' }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: MUTED, marginBottom: '6px' }}>{c.username}</label>
                                <input
                                    type="text"
                                    value={username}
                                    onChange={e => setUsername(e.target.value)}
                                    onKeyDown={e => e.key === 'Enter' && handleReset()}
                                    autoFocus
                                    style={fieldStyle}
                                />
                            </div>

                            {error && (
                                <div style={{ background: ERR_BG, border: `1px solid ${ERR_BORDER}`, padding: '10px 12px', fontSize: '12px', fontWeight: 500, color: ERR_TEXT, marginBottom: '18px' }}>
                                    {error}
                                </div>
                            )}

                            <button onClick={handleReset} className="wlink" style={{ display: 'block', width: '100%', textAlign: 'center', background: 'none', border: 'none', padding: '4px 0', fontFamily: UI_FONT, fontWeight: 700, fontSize: '14px', color: INK, cursor: 'pointer', marginBottom: '20px' }}>{c.submit}</button>

                            <p onClick={() => navigate('/login')} className="wlink" style={{ fontSize: '12px', fontWeight: 500, color: MUTED, textAlign: 'center' }}>
                                {c.back}
                            </p>
                        </>
                    )}
                </div>
            </div>

            <Footer variant="light" />
        </div>
    );
}

export default ForgotPassword;